import store from '../store/store'
import axios from 'axios'
import Vue from 'vue'
import userPlaceHelpers from './userPlaceHelpers'

const vueObj = new Vue()

const getServiceProvince = (parentServiceId) => {
  const globalState = store.getters['globalVal/getState']
  if (globalState.configData && globalState.configData.specific_service_provinces) {
    return globalState.configData.specific_service_provinces.find(data => {
      return data.service_id === parentServiceId
    })
  }
  return null
}

const getService = (serviceId) => {
  const globalState = store.getters['globalVal/getState']
  return globalState.services[serviceId]
}

export default {
  sendResponseMessage (responseMessage) {
    setTimeout(() => {
      store.commit('chatBooking/ADD_MESSAGE', responseMessage)
    }, 1000)
  },
  replyMainMenu (user) {
    store.commit('chatBooking/SET_BOOKING_DATA', null)
    const chatBookingState = store.getters['chatBooking/getState']
    let responseMessage = {
      sender_type: 'bot',
      type: 'template',
      template: {
        type: 'buttons',
        text: 'สวัสดีค่ะยินดีต้อนรับเข้าสู่บีนีทแม่บ้านออนไลน์',
        actions: [
          {
            type: 'message',
            label: 'reservation',
            text: 'จองบริการ',
            style: 'btn-block btn-outline-info'
          }
        ]
      }
    }

    if (user) {
      responseMessage.template.text = `สวัสดีค่ะคุณ ${user.name} ยินดีต้อนรับเข้าสู่บีนีทแม่บ้านออนไลน์`
      const userActions = [
        {
          type: 'message',
          label: 'my-reservations',
          text: 'ดูการจองของฉัน',
          style: 'btn-block btn-outline-info'
        },
        {
          type: 'message',
          label: 'my-reservations-history',
          text: 'ดูการจองที่เสร็จสิ้น และให้รีวิว',
          style: 'btn-block btn-outline-info'
        }
      ]
      // Not partner
      if (!chatBookingState.queryParams.is_partner) {
        userActions.push(
          {
            type: 'message',
            label: 'my-professional',
            text: 'ตรวจสอบคิวว่างของผู้ให้บริการ',
            style: 'btn-block btn-outline-info',
            data: `user_id=${user.id}`
          }
        )
      }
      for (let key in userActions) {
        responseMessage.template.actions.push(userActions[key])
      }
    }
    // Not partner
    if (!chatBookingState.queryParams.is_partner) {
      const action = {
        type: 'uri',
        text: 'กลับสู่หน้า LINE',
        uri: 'https://line.me/R/ti/p/%40hnk7011n',
        style: 'btn-block btn-outline-info'
      }
      responseMessage.template.actions.push(action)
    }
    this.sendResponseMessage(responseMessage)
  },
  replyRequestLogout () {
    const responseMessage = {
      sender_type: 'bot',
      type: 'template',
      template: {
        type: 'buttons',
        text: 'กรุณากดปุ่มด้านล่างเพื่อยืนยันการออกจากระบบค่ะ',
        actions: [
          {
            type: 'confirm',
            label: 'logout',
            text: 'ออกจากระบบ',
            style: 'btn-block btn-outline-info'
          }
        ]
      }
    }
    this.sendResponseMessage(responseMessage)
  },
  replyOrderDetail (order) {
    const url = `orders/${order.id}`
    axios.get(url)
      .then(res => {
        const response = res.data
        if (!response.error) {
          const responseMessage = {
            sender_type: 'bot',
            type: 'order-detail',
            text: 'รายละเอียดการจอง',
            data: response
          }
          this.sendResponseMessage(responseMessage)
        }
      })
      .catch(error => {
        console.log(error)
      })
  },
  async replyServiceRequestDetail (serviceRequest) {
    const url = `service-requests/${serviceRequest.id}`
    const {data} = await axios.get(url)
    if (!data.error) {
      const responseMessage = {
        sender_type: 'bot',
        type: 'service-request-detail',
        text: 'รายละเอียดคำขอ',
        data: data
      }
      this.sendResponseMessage(responseMessage)
    }
  },
  replyRegister () {
    const responseMessage = {
      sender_type: 'bot',
      type: 'register',
      text: 'กรุณากรอกชื่อ เบอร์โทร และอีเมลเพื่อลงทะเบียน'
    }
    this.sendResponseMessage(responseMessage)
  },
  replyOTP (data) {
    // console.log('data', data)
    const responseMessage = {
      sender_type: 'bot',
      type: 'otp',
      text: 'กรุณากรอกรหัส OTP',
      data: data
    }
    this.sendResponseMessage(responseMessage)
  },
  replyCreateUserPlace () {
    const responseMessage = {
      sender_type: 'bot',
      type: 'create-user-place',
      text: 'เพิ่มข้อมูลที่อยู่รับบริการ'
    }
    this.sendResponseMessage(responseMessage)
  },
  replySelectDateTime () {
    const responseMessage = {
      sender_type: 'bot',
      type: 'select-date-time',
      text: 'เลือกวันและเวลา'
    }
    this.sendResponseMessage(responseMessage)
  },
  replyAdditionalRemark () {
    const responseMessage = {
      sender_type: 'bot',
      type: 'additional-remark',
      text: 'หมายเหตุเพิ่มเติม'
    }
    this.sendResponseMessage(responseMessage)
  },
  replyHasIroningBoard () {
    const responseMessage = {
      sender_type: 'bot',
      type: 'has-ironing-board',
      text: 'ที่พักของคุณมีอุปกรณ์ (โต๊ะรีดผ้า) หรือไม่?'
    }
    this.sendResponseMessage(responseMessage)
  },
  replyCreateServiceRequestFirst () {
    const responseMessage = {
      sender_type: 'bot',
      type: 'create-service-request-first',
      text: 'เพิ่มข้อมูลที่อยู่รับบริการ'
    }
    this.sendResponseMessage(responseMessage)
  },
  replyCreateServiceRequestSecond () {
    const responseMessage = {
      sender_type: 'bot',
      type: 'create-service-request-second',
      text: 'เพิ่มข้อมูลที่อยู่รับบริการ'
    }
    this.sendResponseMessage(responseMessage)
  },
  getServices (bookingData) {
    if (bookingData.professional_id) {
      let items = []
      const url = `professionals/${bookingData.professional_id}`
      axios.get(url)
        .then(res => {
          const response = res.data
          if (!response.error) {
            const services = response.professional.services
            for (let key in services) {
              const service = services[key]
              if (response.professional.service_ids.includes(service.id) && service.is_hidden === 0) {
                const item = {
                  type: 'message',
                  label: 'selected-service',
                  text: service.name_th,
                  style: 'btn-secondary',
                  data: `service_id=${service.id}`
                }
                items.push(item)
              }
            }
            const item = {
              type: 'uri',
              label: 'contact',
              text: 'อื่น ๆ (ติดต่อเจ้าหน้าที่)',
              style: 'btn-secondary',
              uri: 'https://line.me/R/ti/p/%40hnk7011n'
            }
            items.push(item)
            const responseMessage = {
              sender_type: 'bot',
              type: 'text',
              text: 'ระบุบริการที่คุณต้องการจอง',
              quickReply: {
                items: items
              }
            }
            this.sendResponseMessage(responseMessage)
          }
        })
        .catch(error => {
          console.log(error)
        })
    } else {
      let items = [
        {
          type: 'message',
          label: 'selected-service',
          text: 'ทำความสะอาดทั่วไป',
          style: 'btn-secondary',
          data: 'service_id=1'
        },
        {
          type: 'message',
          label: 'selected-service',
          text: 'รีดผ้า',
          style: 'btn-secondary',
          data: 'service_id=2'
        }
      ]
      if (bookingData) {
        const globalState = store.getters['globalVal/getState']
        const provinceId = Number(bookingData.province_id)
        const specificServiceIds = globalState.configData.specific_service_provinces.map(data => data.service_id)
        for (const serviceId of specificServiceIds) {
          const serviceProvince = getServiceProvince(serviceId)
          const service = getService(serviceId)
          if (service && serviceProvince && serviceProvince.province_ids.includes(provinceId) && service.is_hidden === 0) {
            items.push({
              type: 'message',
              label: 'selected-service',
              text: service.name_th,
              style: 'btn-secondary',
              data: `service_id=${serviceId}`
            })
          }
        }
      }
      const lastItems = [
        {
          type: 'message',
          label: 'selected-service-request',
          text: 'Big Cleaning',
          style: 'btn-secondary',
          data: 'service_id=13'
        },
        {
          type: 'message',
          label: 'selected-service-request',
          text: 'ซักโซฟา ที่นอน ผ้าม่าน',
          style: 'btn-secondary',
          data: 'service_id=49'
        },
        {
          type: 'message',
          label: 'selected-service-request',
          text: 'พ่นฆ่าเชื้อโรค',
          style: 'btn-secondary',
          data: 'service_id=24'
        },
        {
          type: 'uri',
          label: 'contact',
          text: 'อื่น ๆ (ติดต่อเจ้าหน้าที่)',
          style: 'btn-secondary',
          uri: 'https://line.me/R/ti/p/%40hnk7011n'
        }
      ]
      const finalItems = items.concat(lastItems)
      const responseMessage = {
        sender_type: 'bot',
        type: 'text',
        text: 'ระบุบริการที่คุณต้องการจอง',
        quickReply: {
          items: finalItems
        }
      }
      this.sendResponseMessage(responseMessage)
    }
  },
  getUserPlaces (params) {
    const url = 'users-places'
    axios
      .get(url, {params: params})
      .then(res => {
        const response = res.data
        // Prepare user places data
        let items = []
        if (!response.error) {
          const userPlaces = response.listings
          for (let key in userPlaces) {
            const userPlace = userPlaces[key]
            const fullAddress = userPlaceHelpers.getFullAddress(userPlace)
            let data = `user_place_id=${userPlace.id}&place_name=${userPlace.place_name}&place_size_id=${userPlace.place_size_id}&province_id=${userPlace.province_id}`
            if (userPlace.address_province_id) {
              data += `&address_province_id=${userPlace.address_province_id}`
            }
            if (userPlace.district_id) {
              data += `&district_id=${userPlace.district_id}`
            }
            if (userPlace.sub_district_id) {
              data += `&sub_district_id=${userPlace.sub_district_id}`
            }
            const item = {
              type: 'message',
              label: 'selected-user-place',
              text: userPlace.place_name,
              optional_text: fullAddress,
              style: 'btn-secondary',
              data: data
            }
            items.push(item)
          }
        }
        // Create new user place
        const item = {
          type: 'message',
          label: 'create-user-place',
          style: 'btn-info',
          text: '+ สร้างใหม่'
        }
        items.push(item)

        // Send response message
        const responseMessage = {
          sender_type: 'bot',
          type: 'text',
          text: 'สถานที่ที่คุณต้องการใช้บริการ',
          quickReply: {
            items: items
          }
        }
        this.sendResponseMessage(responseMessage)
      })
      .catch(error => {
        console.log(error)
        vueObj.$swal({text: error.message, type: 'error'})
      })
  },
  getProfessionals (bookingData, services) {
    const userId = bookingData.user_id
    const serviceId = (typeof bookingData.service_id !== 'undefined') ? Number(bookingData.service_id) : null
    const provinceId = (typeof bookingData.province_id !== 'undefined') ? Number(bookingData.province_id) : null
    const url = `users/${userId}/professionals`
    const params = {
      service_id: serviceId,
      province_id: provinceId,
      chat_booking: 1,
      limit: 10
    }
    axios.get(url, {params: params})
      .then(res => {
        const response = res.data
        const params = {
          serviceId: serviceId,
          provinceId: provinceId,
          services: services
        }
        this.performFilterProfessionals(params, response)
      })
      .catch(error => {
        console.log(error)
        vueObj.$swal({text: error.message, type: 'error'})
      })
  },
  performFilterProfessionals (params, response) {
    if (!response.error) {
      const professionals = response.professionals
      const columns = []
      if (professionals) {
        store.commit('chatBooking/UPDATE_BOOKING_DATA', {professionals: professionals})
      }
      // User selected service_id before choosing proessionals
      const parentServiceIds = [1, 2, 15, 16, 39, 51] // Todo::need to add new service id for chat-booking
      if (params.serviceId && parentServiceIds.includes(params.serviceId)) {
        for (let key in professionals) {
          const professional = professionals[key]
          const isServiceAvailable = this.checkProfessionalService(params.serviceId, professional.services)
          if (isServiceAvailable) {
            const column = {
              thumbnailImageUrl: professional.picture,
              title: professional.name,
              text: professional.description,
              data: professional,
              actions: [
                {
                  type: 'message',
                  label: 'selected-professional',
                  text: 'จอง',
                  data: `professional_id=${professional.id}`
                }
              ]
            }
            columns.push(column)
          }
        }

        // Add select any professional (professional_id == 0)
        if (columns.length > 0) {
          // Non-specific professional
          const column = {
            thumbnailImageUrl: 'https://beneat.co/static/img/unknown.png',
            title: 'ไม่ระบุผู้ให้บริการ',
            text: 'ไม่ระบุผู้ให้บริการ',
            data: {province_id: params.provinceId},
            actions: [
              {
                type: 'message',
                label: 'selected-professional',
                text: 'จอง',
                data: `professional_id=0`
              }
            ]
          }
          columns.unshift(column)
        } else {
          const service = getService(params.serviceId)
          if (params.serviceId === 1) {
            this.getWorkHours()
          } else if (service.has_service_items) {
            this.getServiceItems()
          } else {
            this.getChildServices(params)
          }
        }
      } else {
        for (let key in professionals) {
          const professional = professionals[key]
          const column = {
            thumbnailImageUrl: professional.picture,
            title: professional.name,
            text: professional.description,
            data: professional,
            actions: [
              {
                type: 'message',
                label: 'selected-professional',
                text: 'เลือก',
                data: `professional_id=${professional.id}&province_id=${professional.province_id}`
              }
            ]
          }
          columns.push(column)
        }
      }

      const responseMessage = {
        sender_type: 'bot',
        type: 'template',
        template: {
          type: 'carousel',
          text: 'กรุณาเลือกผู้ให้บริการ',
          data_type: 'professional',
          datas: professionals,
          columns: columns
        }
      }
      this.sendResponseMessage(responseMessage)
    } else {
      // Check on professionals in selected services
      store.commit('chatBooking/UPDATE_BOOKING_DATA', {professional_id: 0})
      if (params.serviceId) {
        const service = getService(params.serviceId)
        if (params.serviceId === 1) {
          this.getWorkHours()
        } else if (service.has_service_items) {
          this.getServiceItems()
        } else {
          this.getChildServices(params)
        }
      } else {
        const actions = [
          {
            type: 'message',
            label: 'reservation',
            text: 'จองบริการ',
            style: 'btn-block btn-outline-info'
          }
        ]
        const chatBookingState = store.getters['chatBooking/getState']
        if (!chatBookingState.queryParams.is_partner) {
          actions.push(
            {
              type: 'uri',
              text: 'กลับสู่หน้า LINE',
              uri: 'https://line.me/R/ti/p/%40hnk7011n',
              style: 'btn-block btn-outline-info'
            }
          )
        }
        const responseMessage = {
          sender_type: 'bot',
          type: 'template',
          template: {
            type: 'buttons',
            text: 'คุณยังไม่มีรายการผู้ให้บริการที่คุณเคยจอง หากคุณต้องการจองบริการของบีนีท คุณสามารถกดปุ่มจองบริการได้ค่ะ',
            actions: actions
          }
        }
        this.sendResponseMessage(responseMessage)
      }
    }
  },
  checkProfessionalService (serviceId, services) {
    let result = false
    for (let key in services) {
      const service = services[key]
      if (serviceId === service.id) {
        result = true
        break
      }
    }
    return result
  },
  getServiceSelection (bookingData, services) {
    const serviceId = Number(bookingData.service_id)
    const service = getService(serviceId)
    if (serviceId === 1) {
      this.getWorkHours()
    } else if (service.has_service_items) {
      this.getServiceItems()
    } else {
      const provinceId = Number(bookingData.province_id)
      const params = {
        serviceId: serviceId,
        provinceId: provinceId,
        services: services
      }
      this.getChildServices(params)
    }
  },
  getChildServices (params) {
    const items = []
    for (let key in params.services) {
      const service = params.services[key]
      if (service && params.serviceId === service.parent_id && service.is_hidden === 0) {
        let item = null
        const workHour = service.duration
        if (service.province_id) {
          if (params.provinceId === service.province_id) {
            item = {
              type: 'message',
              label: 'selected-work-hour',
              text: service.name_th,
              data: `work_hour=${workHour}&service_id=${service.id}`,
              style: 'btn-info col-3 m-1'
            }
          }
        } else {
          item = {
            type: 'message',
            label: 'selected-work-hour',
            text: service.name_th,
            data: `work_hour=${workHour}&service_id=${service.id}`,
            style: 'btn-info col-3 m-1'
          }
        }
        if (item) {
          items.push(item)
        }
      }
    }
    // console.log('items', items)
    const responseMessage = {
      sender_type: 'bot',
      type: 'buttons',
      text: 'เลือกจำนวนที่คุณต้องการใช้บริการ',
      buttons: items
    }
    this.sendResponseMessage(responseMessage)
  },
  getWorkHours () {
    const workHours = [2.0, 2.5, 3.0, 3.5, 4.0, 4.5, 6.0, 8.0]
    const items = []
    for (let key in workHours) {
      const workHour = workHours[key]
      const item = {
        type: 'message',
        label: 'selected-work-hour',
        text: `${workHour} ชม.`,
        data: `work_hour=${workHour}`,
        style: 'btn-info col-3 m-1'
      }
      items.push(item)
    }

    const responseMessage = {
      sender_type: 'bot',
      type: 'buttons',
      text: 'จองกี่ชั่วโมงคะ',
      buttons: items
    }
    this.sendResponseMessage(responseMessage)
  },
  getServiceItems () {
    const responseMessage = {
      sender_type: 'bot',
      type: 'service-items',
      text: 'เลือกประเภทและจำนวน'
    }
    this.sendResponseMessage(responseMessage)
  },
  async createChatBooking (bookingData) {
    try {
      const url = `chat-bookings`
      const {data} = await axios.post(url, bookingData)
      if (!data.error) {
        const params = {
          user: {id: bookingData.user_id}
        }
        this.fetchChatBooking(params)
      }
    } catch (error) {
      vueObj.$swal({text: error.message, type: 'error'})
    }
  },
  getBookingSummary (bookingData) {
    const url = `chat-bookings/summary`
    axios.post(url, bookingData)
      .then(res => {
        const response = res.data
        const responseMessage = {
          sender_type: 'bot',
          type: 'booking-summary',
          text: 'สรุปการจอง',
          bookingData: response,
          data: `total_price=${response.total_price}&service_vat=${response.service_vat}`
        }
        this.sendResponseMessage(responseMessage)
      })
      .catch(error => {
        console.log(error)
        vueObj.$swal({text: error.message, type: 'error'})
      })
  },
  replyPaymentSelection () {
    const responseMessage = {
      sender_type: 'bot',
      type: 'payment-method',
      text: 'วิธีการชำระเงิน'
    }
    this.sendResponseMessage(responseMessage)
  },
  replyCreditCardInformation () {
    const responseMessage = {
      sender_type: 'bot',
      type: 'credit-card',
      text: 'ชำระเงินด้วยบัตรเครดิต/เดบิต'
    }
    this.sendResponseMessage(responseMessage)
  },
  replyBankTransferInformation () {
    const responseMessage = {
      sender_type: 'bot',
      type: 'bank-transfer',
      text: 'รายละเอียดข้อมูลสำหรับการโอนเงินค่ะ'
    }
    this.sendResponseMessage(responseMessage)
  },
  replyPromptpayInformation () {
    const responseMessage = {
      sender_type: 'bot',
      type: 'promptpay',
      text: 'ชำระเงินด้วยพร้อมเพย์'
    }
    this.sendResponseMessage(responseMessage)
  },
  replyChangePaymentMethod (paymentMethod, order) {
    const url = `orders/${order.id}`
    axios.get(url)
      .then(res => {
        const response = res.data
        if (!response.error) {
          const responseMessage = {
            sender_type: 'bot',
            type: paymentMethod,
            text: 'รายละเอียดข้อมูลสำหรับการโอนเงินค่ะ',
            data: response
          }
          this.sendResponseMessage(responseMessage)
        }
      })
      .catch(error => {
        console.log(error)
      })
  },
  fetchChatBooking (params) {
    const user = params.user
    store.commit('chatBooking/CLEAR_MESSAGES', true)
    const url = 'chat-bookings'
    axios.get(url, {params: {user_id: user.id}})
      .then(res => {
        const response = res.data
        if (!response.error) {
          const chatBooking = response.chat_booking
          // console.log('chatBooking', chatBooking)
          // Check incomplete payment case
          if (chatBooking && chatBooking.status === 0) {
            const responseMessage = {
              sender_type: 'bot',
              type: 'booking-summary-incomplete',
              text: 'ดำเนินการชำระเงิน',
              bookingData: chatBooking,
              data: `total_price=${chatBooking.total_price}&service_vat=${chatBooking.service_vat}`
            }
            this.sendResponseMessage(responseMessage)
          } else {
            this.replyInitMessage(params)
          }
        } else {
          this.replyInitMessage(params)
        }
      })
      .catch(error => {
        console.log(error)
        vueObj.$swal({text: error.message, type: 'error'})
      })
  },
  async getOrders (data) {
    const url = `orders`
    const params = {
      page: 0,
      user_id: data.user.id,
      status: data.status
    }
    // Fetch upcoming orders
    const responseUpcoming = await axios.get(url, {params: params})
    const upcomingOrdersData = responseUpcoming.data

    // Fetch past orders
    params.status = 'past'
    const responsePast = await axios.get(url, {params: params})
    const pastOrdersData = responsePast.data

    // Include past orders with incomplete payment of service request
    let orders = (!upcomingOrdersData.error) ? upcomingOrdersData.orders : []
    if (!pastOrdersData.error) {
      for (let key in pastOrdersData.orders) {
        const pastOrder = pastOrdersData.orders[key]
        const serviceRequestPaymentStatus = (pastOrder.service_request) ? pastOrder.service_request.payment_status : null
        if (pastOrder.service_request && (serviceRequestPaymentStatus === 3 || serviceRequestPaymentStatus === 1)) {
          orders.push(pastOrder)
        }
      }
    }

    // Set default response message
    let responseMessage = {
      sender_type: 'bot',
      type: 'text',
      text: 'คุณยังไม่มีรายการจองค่ะ'
    }
    if (orders.length > 0) {
      const columns = []
      for (let key in orders) {
        const order = orders[key]
        const picture = 'https://beneat.co/static/img/unknown.png'
        const column = {
          thumbnailImageUrl: picture,
          title: `รหัสการจอง #${order.id}`,
          text: order.cleaning_date,
          actions: [
            {
              type: 'message',
              label: 'selected-order',
              text: 'จอง',
              data: `order_id=${order.id}`
            }
          ]
        }
        columns.push(column)
      }
      responseMessage = {
        sender_type: 'bot',
        type: 'template',
        template: {
          type: 'carousel',
          text: 'การจอง',
          data_type: `order`,
          order_status: data.status,
          datas: orders,
          columns: columns
        }
      }
    }
    this.sendResponseMessage(responseMessage)
  },
  replyText (text) {
    const responseMessage = {
      sender_type: 'bot',
      type: 'template',
      template: {
        type: 'buttons',
        text: text,
        actions: [
          {
            type: 'message',
            label: 'my-reservations',
            text: 'ดูการจองของฉัน',
            style: 'btn-block btn-outline-info'
          }
        ]
      }
    }
    this.sendResponseMessage(responseMessage)
  },
  replyAddLine (user) {
    if (user && user.lineUserId === null) {
      const code = Math.floor(Math.random() * 10000)
      const callback = encodeURIComponent(`https://beneat.co/chat-booking?user_id=${user.id}`)
      const lineUrl = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=1653340017&redirect_uri=${callback}&code=${code}&state=${code}&scope=openid%20profile&bot_prompt=aggressive`
      const responseMessage = {
        sender_type: 'bot',
        type: 'template',
        template: {
          type: 'buttons',
          text: 'การจองของคุณเสร็จสมบูรณ์แล้ว กรุณากดปุ่มเพื่ออนุญาตให้ระบบส่งข้อความแจ้งเตือน เมื่อผู้ให้บริการกดรับงานแล้วค่ะ',
          actions: [
            {
              type: 'uri',
              uri: lineUrl,
              text: 'ตกลง',
              style: 'btn-block btn-outline-info'
            }
          ]
        }
      }
      this.sendResponseMessage(responseMessage)
    }
  },
  checkFinishBooking (user, message) {
    if (user && user.lineUserId === null) {
      this.replyAddLine(user)
    } else {
      this.replyText(message)
    }
  },
  keepLog (queryParams) {
    if (queryParams.ref) {
      const url = 'chat-bookings/log'
      const params = {
        referral_code: queryParams.ref
      }
      axios.post(url, params)
        .then(res => {
          const response = res.data
          console.log('keep log response', response)
        })
        .catch(error => {
          console.log('error', error)
        })
    }
  },
  replyInitMessage (params) {
    const route = params.route
    const user = params.user
    if (route === 'select-professional-first') {
      const message = {
        sender_type: 'user',
        type: 'text',
        label: 'my-professional',
        text: `ตรวจสอบคิวว่างของผู้ให้บริการของคุณ ${user.name}`,
        data: `user_id=${user.id}`
      }
      store.commit('chatBooking/ADD_MESSAGE', message)
    } else {
      store.commit('chatBooking/INIT_MESSAGE', user)
    }
  },
  checkProfessionalAvailableService (bookingData) {
    const professionalId = Number(bookingData.professional_id)
    const serviceId = Number(bookingData.service_id)
    const professionals = bookingData.professionals
    let services = null
    // Search for selected professional
    for (let key in professionals) {
      const professional = professionals[key]
      if (professionalId === professional.id) {
        services = professional.services
        break
      }
    }
    // Search for selected professional service
    for (let key in services) {
      const service = services[key]
      if (serviceId === service.id) {
        return true
      }
    }
    return false
  }
}



// WEBPACK FOOTER //
// ./src/helpers/chatBookingHelpers.js